import { storagePath } from '@helpers/variables'

export const getBookImageUrl = (book) => {
  if (book?.image) return `${storagePath}/${book.image}`

  const section = book?.sections?.find((section) => section.image)

  return section ? `${storagePath}/${section.image}` : null
}
